import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  List,
  Stack,
  Button,
  Divider,
  ListItem,
  Checkbox,
  Typography,
  ListItemText,
} from '@mui/material';

export default function DeleteStatusDeptModal({ status, onDelete, hideModal }) {
  const { t } = useTranslation();

  const [selectedIds, setSelectedIds] = useState([]);

  const toggleSelection = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const handleConfirm = () => {
    onDelete(selectedIds);
    hideModal();
  };

  return (
    <Stack spacing={2} sx={{ p: 1 }}>
      <Typography variant="body2" color="text.secondary">
        {t('pages.statusPage.deleteSelectionInstruction')}
      </Typography>

      <List
        sx={{
          width: '100%',
          bgcolor: 'background.paper',
          maxHeight: 300,
          overflow: 'auto',
        }}
      >
        {status.allDbIds.map((dbId, index) => (
          <React.Fragment key={dbId}>
            <ListItem button onClick={() => toggleSelection(dbId)} sx={{ py: 1 }}>
              <Checkbox
                edge="start"
                checked={selectedIds.includes(dbId)}
                tabIndex={-1}
                disableRipple
              />
              <ListItemText
                primary={status.allDepartmentNames[index]}
                secondary={`ID: #${dbId}`}
              />
            </ListItem>
            <Divider variant="inset" component="li" />
          </React.Fragment>
        ))}
      </List>

      <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
        <Button onClick={hideModal} color="inherit">
          {t('buttons.cancel')}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={selectedIds.length === 0}
        >
          {t('popover.delete')} ({selectedIds.length})
        </Button>
      </Stack>
    </Stack>
  );
}

DeleteStatusDeptModal.propTypes = {
  status: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
};
